import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import AdminLayout from '../../components/admin/AdminLayout';
import userService from '../../services/userService';

/**
 * Componente para mostrar los detalles de un usuario específico
 */
const UserDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        setLoading(true);
        console.log('Intentando obtener usuario con ID:', id);

        // Obtener el usuario por ID
        const userData = await userService.getUserById(id);
        console.log('Usuario obtenido:', userData);

        if (!userData || !userData._id) {
          throw new Error('Datos de usuario inválidos');
        }

        setUser(userData);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching user:', error);
        setError(
          'No se pudo cargar la información del usuario. ' + (error.message || 'Error desconocido'),
        );
        setLoading(false);
      }
    };

    if (id) {
      fetchUser();
    } else {
      setError('ID de usuario no válido');
      setLoading(false);
    }
  }, [id]);

  const handleEditUser = () => {
    navigate(`/admin/users/${id}`);
  };

  if (loading) {
    return (
      <AdminLayout title="Detalles del Usuario" subtitle="Cargando...">
        <div className="loading">Cargando información del usuario...</div>
      </AdminLayout>
    );
  }

  if (error) {
    return (
      <AdminLayout title="Detalles del Usuario" subtitle="Error">
        <div className="error">{error}</div>
        <div className="mt-4">
          <button className="btn btn-primary" onClick={() => navigate('/admin/users')}>
            Volver a Gestión de Usuarios
          </button>
        </div>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout title="Detalles del Usuario" subtitle={`Usuario: ${user.name}`}>
      <div className="admin-card">
        <div className="admin-card-header">
          <h2>Información del Usuario</h2>
          <div className="header-actions">
            <button className="btn btn-secondary" onClick={() => navigate('/admin/users')}>
              Volver
            </button>
            <button className="btn btn-primary" onClick={handleEditUser}>
              Editar Usuario
            </button>
          </div>
        </div>

        <div className="user-details">
          <div className="user-details-header">
            <img
              src={user.avatar || '/img/default-avatar.jpg'}
              alt={user.name}
              className="user-avatar"
            />
            <div className="user-details-info">
              <h3>{user.name}</h3>
              <p className="user-email">{user.email}</p>
              <p className="user-id">ID: {user._id}</p>
            </div>
          </div>

          <div className="user-details-content">
            <div className="detail-row">
              <div className="detail-item">
                <span className="detail-label">Rol:</span>
                <span className={`role-badge ${user.role}`}>
                  {user.role === 'admin' && 'Administrador'}
                  {user.role === 'coach' && 'Entrenador'}
                  {user.role === 'parent' && 'Padre/Madre'}
                  {user.role === 'user' && 'Usuario'}
                </span>
              </div>
              <div className="detail-item">
                <span className="detail-label">Estado:</span>
                <span className={`status-badge ${user.status}`}>
                  {user.status === 'active' && 'Activo'}
                  {user.status === 'pending' && 'Pendiente'}
                  {user.status === 'inactive' && 'Inactivo'}
                </span>
              </div>
            </div>

            <div className="detail-row">
              <div className="detail-item">
                <span className="detail-label">Teléfono:</span>
                <span>{user.phone || 'No especificado'}</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">Fecha de registro:</span>
                <span>{new Date(user.registeredAt).toLocaleDateString('es-ES')}</span>
              </div>
            </div>

            <div className="detail-row">
              <div className="detail-item">
                <span className="detail-label">Saldo:</span>
                <span>{user.walletBalance || 0} €</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">Puntos XP:</span>
                <span>{user.xpPoints || 0}</span>
              </div>
            </div>

            {user.category && (
              <div className="detail-row">
                <div className="detail-item">
                  <span className="detail-label">Categoría:</span>
                  <span>{user.category.name || 'No asignada'}</span>
                </div>
              </div>
            )}

            {user.address && (
              <div className="detail-row">
                <div className="detail-item full-width">
                  <span className="detail-label">Dirección:</span>
                  <span>{user.address}</span>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default UserDetails;
